// import React, { useEffect, useState, useCallback, useMemo } from "react";
// import {
//   Box,
//   Typography,
//   Grid,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Button,
// } from "@mui/material";
// import { Breadcrumb, CTSRinput } from "../../reusableComponent/Reusables";
// import { useNavigate, useLocation } from "react-router-dom";
// import { useForm, Controller } from "react-hook-form";
// import styles from "../../../styles.module.css";
// import dayjs from "dayjs";
// import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
// import plantMasterService from "../../../services/masters/plantMaster.Service";
// import MR_report from "../../../services/report/MR_report";

// const printStyles = `
//   @media print {
//     body * {
//       visibility: hidden;
//     }
//     .printable-area, .printable-area * {
//       visibility: visible;
//     }
//     .printable-area {
//       position: absolute;
//       left: 0;
//       top: 0;
//       width: 100%;
//     }
//     .no-print {
//       display: none !important;
//     }
//     .printable-table {
//       width: 100%;
//       border-collapse: collapse;
//     }
//     .printable-table th, .printable-table td {
//       padding: 8px;
//       font-size: 12px;
//       border: 1px solid #000;
//     }
//     .printable-table .MuiTypography-h6 {
//       font-size: 14px;
//       text-align: center;
//       margin-bottom: 10px;
//     }
//   }
// `;

// const MRReport = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const editData = location.state || null;

//   const login_details = sessionStorage.getItem("loginUser");
//   const userD = JSON.parse(login_details);
//   const userInfo = userD?.result?.userInfo;

//   const [successMessage, setSuccessMessage] = useState("");
//   const [summaryData, setSummaryData] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [plant, setPlant] = useState([]);
  

//   const {
//     watch,
//     control,
//     formState: { errors },
//     setError,
//   } = useForm({
//     defaultValues: {
//       entry_date: editData?.entry_date
//         ? dayjs(editData.entry_date).format("YYYY-MM-DD")
//         : "",
//       plant_id: "",
//     },
//   });

//   const { entry_date, plant_id } = watch();

//   useEffect(() => {
//     async function fetchPlantList() {
//       try {
//         setLoading(true);
//         const plantData = await plantMasterService.getPlantList({
//           page: 0,
//           size: 999,
//           searchKey: "",
//         });
//         setPlant(plantData);
//       } catch (error) {
//         setSuccessMessage("Error fetching plant data");
//         console.error(error);
//       } finally {
//         setLoading(false);
//       }
//     }

//     fetchPlantList();

//     const styleSheet = document.createElement("style");
//     styleSheet.type = "text/css";
//     styleSheet.innerText = printStyles;
//     document.head.appendChild(styleSheet);

//     return () => {
//       document.head.removeChild(styleSheet);
//     };
//   }, []);

//   const handleShow = useCallback(
//     async (formData) => {
//       const { entry_date, plant_id } = formData;

//       if (!entry_date) {
//         setError("entry_date", { message: "Date is required" });
//         return;
//       }

//       if (!plant_id) {
//         setError("plant_id", { message: "Plant is required" });
//         return;
//       }

//       try {
//         setLoading(true);
//         const response = await MR_report.getMRrepotlist({
//           entry_date: dayjs(entry_date).format("YYYY-MM-DD"),
//           plant_id,
//         });
//         setSummaryData(response);
//       } catch (error) {
//         const msg =
//           error?.response?.data?.message || "Failed to fetch MR report";
//         setSuccessMessage(msg);
//         setSummaryData({});
//         console.error(error);
//       } finally {
//         setLoading(false);
//       }
//     },
//     [setError]
//   );

//   const handlePrint = () => {
//     window.print();
//   };

//   useEffect(() => {
//     if (entry_date && plant_id && !errors.entry_date && !errors.plant_id) {
//       handleShow({ entry_date, plant_id });
//     }
//   }, [entry_date, plant_id, errors, handleShow]);

//   const dateConversion = (date) => {
//     if (!date) return "";
//     return dayjs(date).format("DD/MM/YYYY");
//   };
//   // Compute selectedPlantName reactively
//   const selectedPlantName = useMemo(() => {
//     const selected = plant.find((p) => String(p.plant_id) === String(plant_id));
//     console.log("Selected plant_id:", plant_id, "Selected plant:", selected); 
//     return selected?.plant_name || "";
//   }, [plant, plant_id]);

//   const daGeneratorCapacity = summaryData.total_filling_duration
//     ? (45 * 1.0645 * 3 * summaryData.total_filling_duration).toFixed(2):"0";
  
//   return (
//     <Box className={styles.cts_page}>
//       <Box className={styles.body}>
//         <Breadcrumb routeSegments={[{ name: "MR Report" }]} />
//         <Typography className={styles.header_txt}>MR Report</Typography>

//         {/* FILTER CONTROLS */}
//         <Grid container spacing={2} sx={{ mt: 2, mb: 3 }} className="no-print">
//           <Grid item xs={12} sm={6} md={4}>
//             <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//               <Typography className={styles.label_Txt_add}>Plant</Typography>
//               <Controller
//                 name="plant_id"
//                 control={control}
//                 render={({ field }) => (
//                   <select
//                     {...field}
//                     style={{
//                       padding: "6px 12px",
//                       fontSize: 16,
//                       flexGrow: 1,
//                       borderColor: errors.plant_id ? "red" : "#ccc",
//                     }}
//                   >
//                     <option value="">Select Plant</option>
//                     {plant.map((p) => (
//                       <option key={p.plant_id} value={p.plant_id}>
//                         {p.plant_name}
//                       </option>
//                     ))}
//                   </select>
//                 )}
//               />
//             </Box>
//             {errors.plant_id && (
//               <Typography color="error" fontSize={12}>
//                 {errors.plant_id.message}
//               </Typography>
//             )}
//           </Grid>

//           <Grid item xs={12} sm={6} md={4}>
//             <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//               <Typography className={styles.label_Txt_add}>Date</Typography>
//               <Controller
//                 name="entry_date"
//                 control={control}
//                 render={({ field }) => (
//                   <CTSRinput
//                     type="date"
//                     fullWidth
//                     {...field}
//                     size="small"
//                     error={!!errors.entry_date}
//                     helperText={errors.entry_date?.message}
//                     InputProps={{ className: styles.CTSinput_Box }}
//                   />
//                 )}
//               />
//             </Box>
//           </Grid>

//           <Grid item xs={12} sm={6} md={4}>
//             <Button
//               variant="contained"
//               color="primary"
//               onClick={handlePrint}

//             >
//               Print Report
//             </Button>
//           </Grid>
//         </Grid>

//         {summaryData && Object.keys(summaryData).length > 0 && (
//           <Box className="printable-area">
//             {/* === Report Header === */}
//    <Box sx={{ mb: 3, textAlign: "center" }}>
//   <Typography variant="h5" sx={{ fontWeight: "bold" }}>
//     DAILY PRODUCTION & MAINTENANCE REPORT
//   </Typography>
//   <Grid container spacing={2} sx={{ mt: 1 }}>
//   <Grid item xs={6}>
//     <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
//       Date: {dateConversion(entry_date)}
//     </Typography>
//   </Grid>
//   <Grid item xs={6}>
//     <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
//       Plant: {selectedPlantName}
//     </Typography>
//   </Grid>
// </Grid>

// </Box>
//             <Grid container spacing={2}>
//               <Grid item xs={12} md={6}>
//                 <TableContainer component={Paper} className="printable-table">
//                   <Typography variant="h6" sx={{ mb: 1, textAlign: "center" }}>
//                     DA CYLINDER PRODUCTION REPORT
//                   </Typography>
//                   <Table>
//                     <TableBody>
//                       <TableRow>
//                         <TableCell align="left">Report Date:</TableCell>
//                         <TableCell align="center">
//                           {dateConversion(summaryData.report_date)}
//                         </TableCell>
//                       </TableRow>
//                       <TableRow>
//                         <TableCell align="left">No. of Cylinders Filled:</TableCell>
//                         <TableCell align="center">{summaryData.total_cylinders}</TableCell>
//                       </TableRow>
//                       <TableRow>
//                         <TableCell align="left">Quantity Filled:</TableCell>
//                         <TableCell align="center">{summaryData.total_qty_filled} KG</TableCell>
//                       </TableRow>
//                       <TableRow>
//                         <TableCell align="left">Carbide Used:</TableCell>
//                         <TableCell align="center">{summaryData.total_carbide_used} KG</TableCell>
//                       </TableRow>
//                       <TableRow>
//                         <TableCell align="left">Yelid:</TableCell>
//                         <TableCell align="center">
//                           {summaryData.total_carbide_used > 0
//                             ? (summaryData.total_qty_filled / summaryData.total_carbide_used).toFixed(2)
//                             : "0"}{" "}
                          
//                         </TableCell>
//                       </TableRow>
//                       <TableRow>
//                         <TableCell align="left">Average Yield(Last 30  days):</TableCell>
//                         <TableCell align="center">
//                           {summaryData.total_carbide_used > 0
//                             ? ((summaryData.total_qty_filled / summaryData.total_carbide_used) / 30).toFixed(2)
//                             : "0"}{" "}
                          
//                         </TableCell>
//                       </TableRow>
//                       <TableRow>
//                         <TableCell align="left">Acetone Used:</TableCell>
//                         <TableCell align="center">{summaryData.total_acetone_used} KG</TableCell>
//                       </TableRow>
//                       <TableRow>
//                         <TableCell align="left">Total DA Production:</TableCell>
//                         <TableCell align="center">{summaryData.total_qty_filled} KG</TableCell>
//                       </TableRow>
//                       <TableRow>
//                         <TableCell align="left">Total Cylinder Filled Till Date:</TableCell>
//                         <TableCell align="center">{summaryData.total_cylinders_till_now} </TableCell>
//                       </TableRow>
//                       <TableRow>
//                         <TableCell align="left">Total Cylinder Filled Till Date(TGPL):</TableCell>
//                         <TableCell align="center">{summaryData.total_cylinders_tgpl_till_now} </TableCell>
//                       </TableRow>
//                       <TableRow>
//                         <TableCell align="left">Total Cylinder Filled Till Date(Customer):</TableCell>
//                         <TableCell align="center">{summaryData.total_cylinders_customer_till_now} </TableCell>
//                       </TableRow>
//                     </TableBody>
//                   </Table>
//                 </TableContainer>
//               </Grid>

//               <Grid item xs={12} md={6}>
//                 <TableContainer component={Paper} className="printable-table">
//                   <Typography variant="h6" sx={{ mb: 1, textAlign: "center" }}>
//                     CAPACITY UTILISATION
//                   </Typography>
//                   <Table>
//                     <TableBody>
//                       <TableRow>
//                         <TableCell align="left">Plant Capacity:</TableCell>
//                         <TableCell align="center">45 NM3/HR</TableCell>
//                       </TableRow>
//                       <TableRow>
//                         <TableCell align="left">Density Of Acetylene:</TableCell>
//                         <TableCell align="center">1.0645 KG/M3</TableCell>
//                       </TableRow>
//                       <TableRow>
//                         <TableCell align="left">No Of Shifts:</TableCell>
//                         <TableCell align="center">3 Shift</TableCell>
//                       </TableRow>
//                       <TableRow>
//                         <TableCell align="left">Hours Of Operation:</TableCell>
//                         <TableCell align="center">24 HRS</TableCell>
//                       </TableRow>
//                       <TableRow>
//                         <TableCell align="left">Capacity Of DA Generator:</TableCell>
//                         <TableCell align="center">1149.66KG/DAY</TableCell>
//                       </TableRow>
//                       <TableRow>
//                         <TableCell align="left">Actual DA Production:</TableCell>
//                         <TableCell align="center">{summaryData.total_qty_filled} KG</TableCell>
//                       </TableRow>
//                       <TableRow>
//                         <TableCell align="left">Capacity Utilization:</TableCell>
//                         <TableCell align="center">
//                           {summaryData.total_qty_filled && daGeneratorCapacity !== "N/A" && daGeneratorCapacity !== 0
//                             ? ((summaryData.total_qty_filled / daGeneratorCapacity) * 100).toFixed(2) + "%"
//                             : "0"}
//                         </TableCell>
//                       </TableRow>
//                     </TableBody>
//                   </Table>
//                 </TableContainer>
//               </Grid>
//             </Grid>

//             <Grid container spacing={2} sx={{ mt: 2 }}>
//               <Grid item xs={12} md={6}>
//                 <TableContainer component={Paper} className="printable-table">
//                   <Typography variant="h6" sx={{ mb: 1, textAlign: "center" }}>
//                     CARBIDE STOCK & CONSUMPTION REPORT
//                   </Typography>
//                   <Table>
//                     <TableBody>
//                       <TableRow>
//                         <TableCell align="left">Carbide Opening Stock:</TableCell>
//                         <TableCell align="center">{summaryData.opening_carbide_available} KG</TableCell>
//                       </TableRow>
//                       <TableRow>
//                         <TableCell align="left">Carbide Safty Stock:</TableCell>
//                         <TableCell align="center">{summaryData.carbide_stock} KG</TableCell>
//                       </TableRow>
//                       <TableRow>
//                         <TableCell align="left">Carbide Consumption:</TableCell>
//                         <TableCell align="center">{summaryData.total_carbide_used} KG</TableCell>
//                       </TableRow>
//                       <TableRow>
//                         <TableCell align="left">Carbide Closing Stock:</TableCell>
//                         <TableCell align="center">{summaryData.closing_carbide_available} KG</TableCell>
//                       </TableRow>
//                     </TableBody>
//                   </Table>
//                 </TableContainer>
//               </Grid>

//               <Grid item xs={12} md={6}>
//                 <TableContainer component={Paper} className="printable-table">
//                   <Typography variant="h6" sx={{ mb: 1, textAlign: "center" }}>
//                     ACETONE STOCK & CONSUMPTION REPORT
//                   </Typography>
//                   <Table>
//                     <TableBody>
//                       <TableRow>
//                         <TableCell align="left">Acetone Opening Stock:</TableCell>
//                         <TableCell align="center">{summaryData.opening_acetone_available} KG</TableCell>
//                       </TableRow>
//                       <TableRow>
//                         <TableCell align="left">Acetone Safty Stock:</TableCell>
//                         <TableCell align="center">{summaryData.acetone_stock} KG</TableCell>
//                       </TableRow>
//                       <TableRow>
//                         <TableCell align="left">Acetone Consumption:</TableCell>
//                         <TableCell align="center">{summaryData.total_acetone_used} KG</TableCell>
//                       </TableRow>
//                       <TableRow>
//                         <TableCell align="left">Acetone Closing Stock:</TableCell>
//                         <TableCell align="center">{summaryData.closing_acetone_available} KG</TableCell>
//                       </TableRow>
//                     </TableBody>
//                   </Table>
//                 </TableContainer>
//               </Grid>
//             </Grid>
//           </Box>
//         )}

//         {/* SNACKBAR */}
//         <ReusableSnackbar
//           open={!!successMessage}
//           onClose={(e, r) => {
//             if (r !== "clickaway") setSuccessMessage("");
//           }}
//           message={successMessage}
//           autoHideDuration={3000}
//           vertical="top"
//           horizontal="right"
//           className="no-print"
//         />
//       </Box>
//     </Box>
//   );
// };

// export default MRReport;

// import React, { useEffect, useState, useCallback, useMemo } from "react";
// import {
//   Box, Typography, Grid, Paper, Table, TableBody, TableCell,
//   TableContainer, TableHead, TableRow, Button, MenuItem,
// } from "@mui/material";
// import { Breadcrumb, CTSinput, CTSRinput } from "../../reusableComponent/Reusables";
// import { useNavigate, useLocation } from "react-router-dom";
// import { useForm, Controller } from "react-hook-form";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import { Print } from "@mui/icons-material";
// import styles from "../../../styles.module.css";
// import dayjs from "dayjs";
// import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
// import plantMasterService from "../../../services/masters/plantMaster.Service";
// import MR_report from "../../../services/report/MR_report";

// const printStyles = `
//   @media print {
//     body * { visibility: hidden; }
//     .printable-area, .printable-area * { visibility: visible; }
//     .printable-area {
//       position: absolute; left: 0; top: 0;
//       width: 100%; overflow: visible !important;
//       height: auto !important; max-height: none !important;
//     }
//     .no-print { display: none !important; }
//     .mr-section-title {
//       font-size: 13px !important;
//       font-weight: 700 !important;
//       text-align: center;
//       padding: 8px 0;
//     }
//     .mr-table td, .mr-table th {
//       padding: 6px 10px !important;
//       font-size: 11px !important;
//       border: 1px solid #ddd !important;
//     }
//   }
// `;

// /* ── Reusable section card ── */
// const SectionCard = ({ title, children }) => (
//   <Box sx={{ background: "#fff", border: "1px solid #E2E8F0", overflow: "hidden", height: "100%" }}>
//     <Box sx={{ background: "#2A4F7A", padding: "9px 18px" }}>
//       <Typography sx={{
//         fontSize: "12px", fontWeight: 700, color: "#fff",
//         letterSpacing: "0.4px", fontFamily: "'Inter', Arial, sans-serif",
//         textAlign: "center", textTransform: "uppercase",
//       }} className="mr-section-title">
//         {title}
//       </Typography>
//     </Box>
//     <Table size="small" className="mr-table">
//       <TableBody>{children}</TableBody>
//     </Table>
//   </Box>
// );

// /* ── Reusable data row ── */
// const DataRow = ({ label, value }) => (
//   <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#F8FAFC" }, "&:hover": { backgroundColor: "#EBF4FF" } }}>
//     <TableCell sx={{ fontSize: "12px", color: "#4A5568", fontFamily: "'Inter', Arial, sans-serif", borderBottom: "1px solid #EDF2F7", padding: "9px 14px", width: "60%" }}>
//       {label}
//     </TableCell>
//     <TableCell sx={{ fontSize: "12px", fontWeight: 600, color: "#1C3A5E", fontFamily: "'Inter', Arial, sans-serif", borderBottom: "1px solid #EDF2F7", padding: "9px 14px", textAlign: "center" }}>
//       {value ?? "—"}
//     </TableCell>
//   </TableRow>
// );

// const MRReport = () => {
//   const location = useLocation();
//   const editData = location.state || null;

//   const [successMessage, setSuccessMessage] = useState("");
//   const [summaryData, setSummaryData]       = useState({});
//   const [loading, setLoading]               = useState(false);
//   const [plant, setPlant]                   = useState([]);

//   const { watch, control, formState: { errors }, setError } = useForm({
//     defaultValues: {
//       entry_date: editData?.entry_date ? dayjs(editData.entry_date).format("YYYY-MM-DD") : "",
//       plant_id: "",
//     },
//   });

//   const { entry_date, plant_id } = watch();

//   useEffect(() => {
//     async function fetchPlantList() {
//       try {
//         setLoading(true);
//         const plantData = await plantMasterService.getPlantList({ page: 0, size: 999, searchKey: "" });
//         setPlant(plantData);
//       } catch (error) {
//         setSuccessMessage("Error fetching plant data");
//       } finally { setLoading(false); }
//     }
//     fetchPlantList();

//     const styleSheet = document.createElement("style");
//     styleSheet.type = "text/css";
//     styleSheet.innerText = printStyles;
//     document.head.appendChild(styleSheet);
//     return () => { document.head.removeChild(styleSheet); };
//   }, []);

//   const handleShow = useCallback(async (formData) => {
//     const { entry_date, plant_id } = formData;
//     if (!entry_date) { setError("entry_date", { message: "Date is required" });  return; }
//     if (!plant_id)   { setError("plant_id",   { message: "Plant is required" }); return; }
//     try {
//       setLoading(true);
//       const response = await MR_report.getMRrepotlist({
//         entry_date: dayjs(entry_date).format("YYYY-MM-DD"),
//         plant_id,
//       });
//       setSummaryData(response);
//     } catch (error) {
//       setSuccessMessage(error?.response?.data?.message || "Failed to fetch MR report");
//       setSummaryData({});
//     } finally { setLoading(false); }
//   }, [setError]);

//   useEffect(() => {
//     if (entry_date && plant_id && !errors.entry_date && !errors.plant_id) {
//       handleShow({ entry_date, plant_id });
//     }
//   }, [entry_date, plant_id, errors, handleShow]);

//   const dateConversion = (date) => date ? dayjs(date).format("DD/MM/YYYY") : "";

//   const selectedPlantName = useMemo(() => {
//     return plant.find(p => String(p.plant_id) === String(plant_id))?.plant_name || "";
//   }, [plant, plant_id]);

//   const daGeneratorCapacity = summaryData.total_filling_duration
//     ? (45 * 1.0645 * 3 * summaryData.total_filling_duration).toFixed(2) : "0";

//   const hasData = summaryData && Object.keys(summaryData).length > 0;

//   return (
//     <Box className={styles.cts_page} sx={{ padding: "0px !important", margin: "0px !important" }}>
//       <Box className={styles.body}>
//         <Breadcrumb routeSegments={[{ name: "MR Report" }]} />
//         <Typography className={styles.header_txt}>MR REPORT</Typography>

//         {/* ── Filter Row ── */}
//         <Box
//           className="no-print"
//           sx={{ display: "flex", flexWrap: "wrap", alignItems: "flex-end", gap: "12px", mb: 2, width: "100%" }}
//         >
//           {/* Plant */}
//           <Box sx={{ display: "flex", flexDirection: "column", flex: "1 1 150px", minWidth: "150px", maxWidth: { xs: "100%", sm: "240px" } }}>
//             <Typography sx={{ fontSize: "12px", fontWeight: 500, color: "text.secondary", mb: "4px", whiteSpace: "nowrap" }}>
//               Plant <span style={{ color: "red" }}>*</span>
//             </Typography>
//             <Controller name="plant_id" control={control} render={({ field }) => (
//               <CTSinput select size="small" fullWidth {...field}
//                 error={!!errors.plant_id}
//                 InputProps={{ className: styles.CTSinput_Box }}
//               >
//                 <MenuItem value=""><em>Select Plant</em></MenuItem>
//                 {plant.map(p => <MenuItem key={p.plant_id} value={p.plant_id}>{p.plant_name}</MenuItem>)}
//               </CTSinput>
//             )} />
//             {errors.plant_id && <Typography sx={{ fontSize: "11px", color: "red", mt: "2px" }}>{errors.plant_id.message}</Typography>}
//           </Box>

//           {/* Date */}
//           <Box sx={{ display: "flex", flexDirection: "column", flex: "1 1 140px", minWidth: "150px", maxWidth: { xs: "100%", sm: "220px" } }}>
//             <Typography sx={{ fontSize: "12px", fontWeight: 500, color: "text.secondary", mb: "4px", whiteSpace: "nowrap" }}>
//               Date <span style={{ color: "red" }}>*</span>
//             </Typography>
//             <Controller name="entry_date" control={control} render={({ field }) => (
//               <CTSRinput size="small" fullWidth type="date" {...field}
//                 error={!!errors.entry_date} helperText={errors.entry_date?.message}
//                 InputProps={{ className: styles.CTSinput_Box }} />
//             )} />
//           </Box>

//           {/* Buttons */}
//           <Box sx={{ display: "flex", alignItems: "flex-end", gap: "8px", flex: "0 0 auto" }}>
//             <Button
//               variant="contained" startIcon={<VisibilityIcon />}
//               onClick={() => handleShow({ entry_date, plant_id })}
//               className={styles.addnew_btn}
//               disabled={loading}
//               size="small" sx={{ height: "30px", whiteSpace: "nowrap" }}
//             >
//               <Typography className={styles.addnew_btn_txt}>Show</Typography>
//             </Button>
//             <Button
//               variant="outlined" startIcon={<Print />}
//               onClick={() => window.print()}
//               disabled={!hasData} size="small"
//               sx={{ whiteSpace: "nowrap", height: "30px" }}
//             >
//               Print
//             </Button>
//           </Box>
//         </Box>

//         {/* ── Report Content ── */}
//         {hasData && (
//           <Box className="printable-area">

//             {/* Report Title Header */}
//             <Box sx={{
//                padding: "16px 24px", mb: 2.5,
//               display: "flex", alignItems: "center", justifyContent: "space-between",
//               flexWrap: "wrap", gap: 1,
//             }}>
//               <Typography sx={{ fontSize: "16px", fontWeight: 700, color: "#192434", letterSpacing: "0.8px", fontFamily: "'Inter', Arial, sans-serif" }}>
//                 DAILY PRODUCTION & MAINTENANCE REPORT
//               </Typography>
//               <Box sx={{ display: "flex", gap: 3 }}>
//                 <Box>
//                   <Typography sx={{ fontSize: "10px", color: "rgba(255,255,255,0.65)", fontFamily: "'Inter', Arial, sans-serif", textTransform: "uppercase", letterSpacing: "0.5px" }}>Date</Typography>
//                   <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#192434", fontFamily: "'Inter', Arial, sans-serif" }}>{dateConversion(entry_date)}</Typography>
//                 </Box>
//                 <Box>
//                   <Typography sx={{ fontSize: "10px", color: "rgba(255,255,255,0.65)", fontFamily: "'Inter', Arial, sans-serif", textTransform: "uppercase", letterSpacing: "0.5px" }}>Plant</Typography>
//                   <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#192434", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedPlantName}</Typography>
//                 </Box>
//               </Box>
//             </Box>

//             {/* Row 1: DA Cylinder + Capacity */}
//             <Grid container spacing={2} sx={{ mb: 2 }}>
//               <Grid item xs={12} md={6}>
//                 <SectionCard title="DA Cylinder Production Report">
//                   <DataRow label="Report Date"                               value={dateConversion(summaryData.report_date)} />
//                   <DataRow label="No. of Cylinders Filled"                   value={summaryData.total_cylinders} />
//                   <DataRow label="Quantity Filled"                           value={summaryData.total_qty_filled ? `${summaryData.total_qty_filled} KG` : "—"} />
//                   <DataRow label="Carbide Used"                              value={summaryData.total_carbide_used ? `${summaryData.total_carbide_used} KG` : "—"} />
//                   <DataRow label="Yield"
//                     value={summaryData.total_carbide_used > 0
//                       ? (summaryData.total_qty_filled / summaryData.total_carbide_used).toFixed(2) : "0"} />
//                   <DataRow label="Average Yield (Last 30 Days)"
//                     value={summaryData.total_carbide_used > 0
//                       ? ((summaryData.total_qty_filled / summaryData.total_carbide_used) / 30).toFixed(2) : "0"} />
//                   <DataRow label="Acetone Used"                              value={summaryData.total_acetone_used ? `${summaryData.total_acetone_used} KG` : "—"} />
//                   <DataRow label="Total DA Production"                       value={summaryData.total_qty_filled ? `${summaryData.total_qty_filled} KG` : "—"} />
//                   <DataRow label="Total Cylinders Filled Till Date"          value={summaryData.total_cylinders_till_now} />
//                   <DataRow label="Total Cylinders Filled Till Date (TGPL)"   value={summaryData.total_cylinders_tgpl_till_now} />
//                   <DataRow label="Total Cylinders Filled Till Date (Customer)" value={summaryData.total_cylinders_customer_till_now} />
//                 </SectionCard>
//               </Grid>

//               <Grid item xs={12} md={6}>
//                 <SectionCard title="Capacity Utilisation">
//                   <DataRow label="Plant Capacity"         value="45 NM3/HR" />
//                   <DataRow label="Density of Acetylene"   value="1.0645 KG/M3" />
//                   <DataRow label="No of Shifts"           value="3 Shift" />
//                   <DataRow label="Hours of Operation"     value="24 HRS" />
//                   <DataRow label="Capacity of DA Generator" value="1149.66 KG/DAY" />
//                   <DataRow label="Actual DA Production"   value={summaryData.total_qty_filled ? `${summaryData.total_qty_filled} KG` : "—"} />
//                   <DataRow label="Capacity Utilization"
//                     value={summaryData.total_qty_filled && daGeneratorCapacity !== "0"
//                       ? `${((summaryData.total_qty_filled / daGeneratorCapacity) * 100).toFixed(2)}%` : "0%"} />
//                 </SectionCard>
//               </Grid>
//             </Grid>

//             {/* Row 2: Carbide + Acetone */}
//             <Grid container spacing={2}>
//               <Grid item xs={12} md={6}>
//                 <SectionCard title="Carbide Stock & Consumption Report">
//                   <DataRow label="Carbide Opening Stock"    value={summaryData.opening_carbide_available ? `${summaryData.opening_carbide_available} KG` : "—"} />
//                   <DataRow label="Carbide Safety Stock"     value={summaryData.carbide_stock ? `${summaryData.carbide_stock} KG` : "—"} />
//                   <DataRow label="Carbide Consumption"      value={summaryData.total_carbide_used ? `${summaryData.total_carbide_used} KG` : "—"} />
//                   <DataRow label="Carbide Closing Stock"    value={summaryData.closing_carbide_available ? `${summaryData.closing_carbide_available} KG` : "—"} />
//                 </SectionCard>
//               </Grid>

//               <Grid item xs={12} md={6}>
//                 <SectionCard title="Acetone Stock & Consumption Report">
//                   <DataRow label="Acetone Opening Stock"    value={summaryData.opening_acetone_available ? `${summaryData.opening_acetone_available} KG` : "—"} />
//                   <DataRow label="Acetone Safety Stock"     value={summaryData.acetone_stock ? `${summaryData.acetone_stock} KG` : "—"} />
//                   <DataRow label="Acetone Consumption"      value={summaryData.total_acetone_used ? `${summaryData.total_acetone_used} KG` : "—"} />
//                   <DataRow label="Acetone Closing Stock"    value={summaryData.closing_acetone_available ? `${summaryData.closing_acetone_available} KG` : "—"} />
//                 </SectionCard>
//               </Grid>
//             </Grid>

//           </Box>
//         )}

//         {/* No data placeholder */}
//         {!hasData && !loading && (
//           <Box sx={{ mt: 4, display: "flex", justifyContent: "center" }}>
//             <Typography sx={{ color: "#A0AEC0", fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif" }}>
//               Select a plant and date, then click Show to load the report.
//             </Typography>
//           </Box>
//         )}

//         <ReusableSnackbar
//           open={!!successMessage}
//           onClose={(e, r) => { if (r !== "clickaway") setSuccessMessage(""); }}
//           message={successMessage}
//           autoHideDuration={3000}
//           vertical="top" horizontal="right"
//           className="no-print"
//         />
//       </Box>
//     </Box>
//   );
// };

// export default MRReport;


import React, { useEffect, useState, useCallback, useMemo } from "react";
import {
  Box, Typography, Grid, Paper, Table, TableBody, TableCell,TableHead,
  TableContainer, TableRow, Button, MenuItem,
} from "@mui/material";
import { Breadcrumb, CTSinput, CTSRinput } from "../../reusableComponent/Reusables";
import { useLocation } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Print } from "@mui/icons-material";
import styles from "../../../styles.module.css";
import dayjs from "dayjs";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import plantMasterService from "../../../services/masters/plantMaster.Service";
import MR_report from "../../../services/report/MR_report";
import productionQuantityReportService from "../../../services/report/production_quantity_report.Service";

const printStyles = `
  @media print {
    body * { visibility: hidden; }
    .printable-area, .printable-area * { visibility: visible; }
    .printable-area {
      position: absolute; left: 0; top: 0;
      width: 100%; overflow: visible !important;
      height: auto !important; max-height: none !important;
    }
    .no-print { display: none !important; }

    /* ── Report header ── */
    .print-report-header {
      background: #D0D0D0 !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
    .print-report-header * { color: #000 !important; }

    /* ── Section headers ── */
    .print-section-header {
      background: #B0B0B0 !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
    .print-section-header * { color: #000 !important; }

    /* ── Table rows ── */
    .mr-table tr:nth-child(odd) td {
      background: #F0F0F0 !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
    .mr-table tr:nth-child(even) td {
      background: #FFFFFF !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
    .mr-table td {
      padding: 8px 14px !important;
      font-size: 11px !important;
      color: #000 !important;
      border-bottom: 1px solid #CCCCCC !important;
    }
      /* ── Production Quantity table header ── */
    .pqr-print-header-row {
      background: #1C3A5E !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
    .pqr-print-header-row td {
      background: #1C3A5E !important;
      color: #fff !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
   /* ── Production Quantity table — same grey header as other sections in print ── */
    .pqr-table th {
      background: #B0B0B0 !important;
      color: #000 !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
    .pqr-table td {
      color: #000 !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
      

    /* ── Outer wrapper: single form-like border ── */
    .print-container {
      border: 1px solid #555 !important;
      border-radius: 4px !important;
      display: flex !important;
      flex-direction: column !important;
      gap: 12px !important;
      padding: 12px !important;
      background: #fff !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }

    /* ── Each row of 2 cards ── */
    .print-row {
      display: flex !important;
      flex-direction: row !important;
      gap: 12px !important;
      width: 100% !important;
    }

    /* ── Each individual card gets its own box ── */
    .print-grid-cell {
      border: 1.5px solid #888 !important;
      border-radius: 3px !important;
      overflow: hidden !important;
      flex: 1 !important;
      min-width: 0 !important;
    }
  }
`;

/* ── Section card ── */
const SectionCard = ({ title, children }) => (
  <Box className="print-grid-cell" sx={{ background: "#fff", border: "1px solid #E2E8F0", overflow: "hidden", height: "100%" }}>
    <Box className="print-section-header" sx={{ background: "#2A4F7A", padding: "9px 18px" }}>
      <Typography sx={{
        fontSize: "12px", fontWeight: 700, color: "#fff",
        letterSpacing: "0.4px", fontFamily: "'Inter', Arial, sans-serif",
        textAlign: "center", textTransform: "uppercase",
      }}>
        {title}
      </Typography>
    </Box>
    <Table size="small" className="mr-table">
      <TableBody>{children}</TableBody>
    </Table>
  </Box>
);

/* ── Data row ── */
const DataRow = ({ label, value }) => (
  <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#F8FAFC" }, "&:hover": { backgroundColor: "#EBF4FF" } }}>
    <TableCell sx={{ fontSize: "12px", color: "#4A5568", fontFamily: "'Inter', Arial, sans-serif", borderBottom: "1px solid #EDF2F7", padding: "9px 14px", width: "60%" }}>
      {label}
    </TableCell>
    <TableCell sx={{ fontSize: "12px", fontWeight: 600, color: "#1C3A5E", fontFamily: "'Inter', Arial, sans-serif", borderBottom: "1px solid #EDF2F7", padding: "9px 14px", textAlign: "center" }}>
      {value ?? "—"}
    </TableCell>
  </TableRow>
);

const MRReport = () => {
  const location = useLocation();
  const editData = location.state || null;

  const [successMessage, setSuccessMessage] = useState("");
  const [summaryData, setSummaryData]       = useState({});
  const [loading, setLoading]               = useState(false);
  const [plant, setPlant]                   = useState([]);
const [pqrData, setPqrData] = useState(null);
  const { watch, control, handleSubmit, formState: { errors }, setError } = useForm({
  defaultValues: {
  entry_date: editData?.entry_date ? dayjs(editData.entry_date).format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD"),
  plant_id: "",
},
  });

  const { entry_date, plant_id } = watch();

  useEffect(() => {
    async function fetchPlantList() {
      try {
        setLoading(true);
        const plantData = await plantMasterService.getPlantList({ page: 0, size: 999, searchKey: "" });
        setPlant(plantData);
      } catch (error) {
        setSuccessMessage("Error fetching plant data");
      } finally { setLoading(false); }
    }
    fetchPlantList();

    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = printStyles;
    document.head.appendChild(styleSheet);
    return () => { document.head.removeChild(styleSheet); };
  }, []);

  const handleShow = useCallback(async (formData) => {
    const { entry_date, plant_id } = formData;
    if (!entry_date) { setError("entry_date", { message: "Date is required" });  return; }
    if (!plant_id)   { setError("plant_id",   { message: "Plant is required" }); return; }
    try {
      setLoading(true);
      const response = await MR_report.getMRrepotlist({
        entry_date: dayjs(entry_date).format("YYYY-MM-DD"),
        plant_id,
      });
      console.log('MR Report response:', response);
      setSummaryData(response);
      try {
  const pqrRes = await productionQuantityReportService.getSummary({
    start_date: dayjs(entry_date).format("YYYY-MM-DD"),
    end_date: dayjs(entry_date).format("YYYY-MM-DD"),
  });
  setPqrData(pqrRes);
} catch (pqrErr) {
  console.error("Production Quantity fetch failed:", pqrErr);
  setPqrData(null);
}
    } catch (error) {
      setSuccessMessage(error?.response?.data?.message || "Failed to fetch MR report");
      setSummaryData({});
    } finally { setLoading(false); }
  }, [setError]);

  const dateConversion = (date) => date ? dayjs(date).format("DD/MM/YYYY") : "";

  const selectedPlantName = useMemo(() => {
    return plant.find(p => String(p.plant_id) === String(plant_id))?.plant_name || "";
  }, [plant, plant_id]);

  const daGeneratorCapacity = summaryData.total_filling_duration
    ? (45 * 1.0645 * 3 * summaryData.total_filling_duration).toFixed(2) : "0";

  const hasData = summaryData && Object.keys(summaryData).length > 0;

  return (
    <Box className={styles.cts_page} sx={{ padding: "0px !important", margin: "0px !important" }}>
      <Box className={styles.body}>
        <Breadcrumb routeSegments={[{ name: "MR Report" }]} />
        <Typography className={styles.header_txt}>MR REPORT</Typography>

        {/* ── Filter Row ── */}
        <Box
          className="no-print"
          component="form"
          onSubmit={handleSubmit(handleShow)}
          sx={{ display: "flex", flexWrap: "wrap", alignItems: "flex-end", gap: "12px", mb: 2, width: "100%" }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", flex: "1 1 150px", minWidth: "150px", maxWidth: { xs: "100%", sm: "240px" } }}>
            <Typography sx={{ fontSize: "12px", fontWeight: 500, color: "text.secondary", mb: "4px", whiteSpace: "nowrap" }}>
              Plant <span style={{ color: "red" }}>*</span>
            </Typography>
            <Controller name="plant_id" control={control} render={({ field }) => (
              <CTSinput select size="small" fullWidth {...field}
                error={!!errors.plant_id}
                InputProps={{ className: styles.CTSinput_Box }}
              >
                {/* <MenuItem value=""><em>Select Plant</em></MenuItem> */}
                {plant.map(p => <MenuItem key={p.plant_id} value={p.plant_id}>{p.plant_name}</MenuItem>)}
              </CTSinput>
            )} />
            {errors.plant_id && <Typography sx={{ fontSize: "11px", color: "red", mt: "2px" }}>{errors.plant_id.message}</Typography>}
          </Box>

          <Box sx={{ display: "flex", flexDirection: "column", flex: "1 1 140px", minWidth: "150px", maxWidth: { xs: "100%", sm: "220px" } }}>
            <Typography sx={{ fontSize: "12px", fontWeight: 500, color: "text.secondary", mb: "4px", whiteSpace: "nowrap" }}>
              Date <span style={{ color: "red" }}>*</span>
            </Typography>
            <Controller name="entry_date" control={control} render={({ field }) => (
              <CTSRinput size="small" fullWidth type="date" {...field}
                error={!!errors.entry_date} helperText={errors.entry_date?.message}
                InputProps={{ className: styles.CTSinput_Box }} />
            )} />
          </Box>

          <Box sx={{ display: "flex", alignItems: "flex-end", gap: "8px", flex: "0 0 auto" }}>
            <Button
              variant="contained" startIcon={<VisibilityIcon />} type="submit"
              className={styles.addnew_btn} disabled={loading}
              size="small" sx={{ height: "30px", whiteSpace: "nowrap" }}
            >
              <Typography className={styles.addnew_btn_txt}>Show</Typography>
            </Button>
            <Button
              variant="outlined" startIcon={<Print />}
              onClick={() => window.print()}
              disabled={!hasData} size="small"
              sx={{ whiteSpace: "nowrap", height: "30px" }}
            >
              Print
            </Button>
          </Box>
        </Box>

 {/* ── Report Content ── */}
        {hasData && (
          <Box className="printable-area">

            {/* Report Title Header */}
            <Box
              className="print-report-header"
              sx={{
                background: "#1C3A5E", padding: "4px 20px", mb: 2,
                display: "flex", alignItems: "center", justifyContent: "space-between",
                flexWrap: "wrap", gap: 1,
              }}
            >
              <Typography sx={{ fontSize: "15px", fontWeight: 700, color: "#fff", letterSpacing: "0.8px", fontFamily: "'Inter', Arial, sans-serif" }}>
                DAILY PRODUCTION & MAINTENANCE REPORT
              </Typography>
              <Box sx={{ display: "flex", gap: 3 }}>
                <Box>
                  <Typography sx={{ fontSize: "10px", color: "rgba(255,255,255,0.65)", fontFamily: "'Inter', Arial, sans-serif", textTransform: "uppercase", letterSpacing: "0.5px" }}>Date</Typography>
                  <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#fff", fontFamily: "'Inter', Arial, sans-serif" }}>{dateConversion(entry_date)}</Typography>
                </Box>
                <Box>
                  <Typography sx={{ fontSize: "10px", color: "rgba(255,255,255,0.65)", fontFamily: "'Inter', Arial, sans-serif", textTransform: "uppercase", letterSpacing: "0.5px" }}>Plant</Typography>
                  <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#fff", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedPlantName}</Typography>
                </Box>
              </Box>
            </Box>

            {/* 
              Screen : flex column with gap — 2 rows x 2 cols (same as original)
              Print  : .print-container = single outer border
                       .print-row       = flex row, no gap, internal dividers only
                       .print-grid-cell = no individual border
            */}
            <Box
              className="print-container"
              sx={{ display: "flex", flexDirection: "column", gap: 2 }}
            >
              {/* Row 1 — DA Cylinder + Capacity */}
              <Box className="print-row" sx={{ display: "flex", gap: 2, alignItems: "stretch" }}>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <SectionCard title="DA Cylinder Production Report">
                    <DataRow label="Report Date"                                  value={dateConversion(summaryData.report_date)} />
                    <DataRow label="No. of Cylinders Filled"                      value={summaryData.total_cylinders} />
                  <DataRow label="Quantity Filled"                              value={summaryData.total_qty_filled_with_topup != null ? `${summaryData.total_qty_filled_with_topup} KG` : (summaryData.total_qty_filled ? `${summaryData.total_qty_filled} KG` : "—")} />
                    <DataRow label="Carbide Used"                                 value={summaryData.total_carbide_used ? `${summaryData.total_carbide_used} KG` : "—"} />
                    <DataRow label="Yield"
                      value={summaryData.total_yield != null ? summaryData.total_yield.toFixed(2) : "0"} />
                  <DataRow label="Average Yield (Last 30 Days)"
  value={summaryData.avg_yield_last_30_days != null ? summaryData.avg_yield_last_30_days.toFixed(2) : "0"} />
                    <DataRow label="Acetone Used"                                 value={summaryData.total_acetone_used ? `${summaryData.total_acetone_used} KG` : "—"} />
                    <DataRow label="Total DA Production"                          value={summaryData.total_qty_filled ? `${summaryData.total_qty_filled} KG` : "—"} />
                    <DataRow label="Total Cylinders Filled Till Date"             value={summaryData.total_cylinders_till_now} />
                    <DataRow label="Total Cylinders Filled Till Date (TGPL)"      value={summaryData.total_cylinders_tgpl_till_now} />
                    <DataRow label="Total Cylinders Filled Till Date (Customer)"  value={summaryData.total_cylinders_customer_till_now} />
                  </SectionCard>
                </Box>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <SectionCard title="Capacity Utilisation">
                    <DataRow label="Plant Capacity"           value="45 NM3/HR" />
                    <DataRow label="Density of Acetylene"     value="1.0645 KG/M3" />
                    <DataRow label="No of Shifts"             value="3 Shift" />
                    <DataRow label="Hours of Operation"       value="24 HRS" />
                    <DataRow label="Capacity of DA Generator" value="1149.66 KG/DAY" />
                    <DataRow label="Actual DA Production"     value={summaryData.total_qty_filled ? `${summaryData.total_qty_filled} KG` : "—"} />
                    <DataRow label="Capacity Utilization"
                      value={summaryData.total_qty_filled && daGeneratorCapacity !== "0"
                        ? `${((summaryData.total_qty_filled / daGeneratorCapacity) * 100).toFixed(2)}%` : "0%"} />
                  </SectionCard>
                </Box>
              </Box>

              {/* Row 2 — Carbide + Acetone */}
              <Box className="print-row" sx={{ display: "flex", gap: 2, alignItems: "stretch" }}>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <SectionCard title="Carbide Stock & Consumption Report">
                    <DataRow label="Carbide Opening Stock"  value={summaryData.opening_carbide_available != null ? `${summaryData.opening_carbide_available} KG` : "—"} />
                    {/* <DataRow label="Carbide Safety Stock"   value={summaryData.carbide_stock != null ? `${summaryData.carbide_stock} KG` : "—"} /> */}
                    <DataRow label="Carbide Consumption"    value={summaryData.total_carbide_used ? `${summaryData.total_carbide_used} KG` : "—"} />
                    <DataRow label="Carbide Closing Stock"  value={summaryData.closing_carbide_available != null ? `${summaryData.closing_carbide_available} KG` : "—"} />
                     <DataRow label="Carbide Safety Stock"   value={summaryData.carbide_stock != null ? `${summaryData.carbide_stock} KG` : "—"} />
                  </SectionCard>
                </Box>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <SectionCard title="Acetone Stock & Consumption Report">
                <DataRow label="Acetone Opening Stock"  value={summaryData.opening_acetone_available != null ? `${summaryData.opening_acetone_available} KG` : "—"} />
{/* <DataRow label="Acetone Safety Stock"   value={summaryData.acetone_stock != null ? `${summaryData.acetone_stock} KG` : "—"} /> */}
<DataRow label="Acetone Consumption"    value={summaryData.total_acetone_used != null ? `${summaryData.total_acetone_used} KG` : "—"} />
<DataRow label="Acetone Closing Stock"  value={summaryData.closing_acetone_available != null ? `${summaryData.closing_acetone_available} KG` : "—"} />
<DataRow label="Acetone Safety Stock"   value={summaryData.acetone_stock != null ? `${summaryData.acetone_stock} KG` : "—"} />
                  </SectionCard>
                </Box>
              </Box>
           


         {/* ✅ Row 3 — Production Quantity Summary (simple table, no title bar/card wrapper) */}
              {pqrData && (
                <Box sx={{ mt: 0 }}>
                  <Table size="small" className="pqr-table" sx={{ border: "1px solid #E2E8F0" }}>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ background: "#1C3A5E", color: "#fff", fontSize: "12px", fontWeight: 600, textAlign: "center", padding: "9px 14px" }}>
                          Quantity Filled in Cylinder (CUM)
                        </TableCell>
                        <TableCell sx={{ background: "#1C3A5E", color: "#fff", fontSize: "12px", fontWeight: 600, textAlign: "center", padding: "9px 14px" }}>
                          Quantity Topped up (CUM)
                        </TableCell>
                        <TableCell sx={{ background: "#1C3A5E", color: "#fff", fontSize: "12px", fontWeight: 600, textAlign: "center", padding: "9px 14px" }}>
                          Quantity Billed (CUM)
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell sx={{ fontSize: "13px", textAlign: "center", padding: "9px 14px" }}>{pqrData.qty_filled_cum}</TableCell>
                        <TableCell sx={{ fontSize: "13px", textAlign: "center", padding: "9px 14px" }}>{pqrData.qty_topped_up_cum}</TableCell>
                        <TableCell sx={{ fontSize: "13px", textAlign: "center", padding: "9px 14px" }}>{pqrData.qty_billed_cum}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                  <Box sx={{ p: 1.5, borderTop: "none", display: "flex", justifyContent: "flex-end" }}>
                    {/* <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "#1C3A5E" }}>
                      Total Production Quantity: <span style={{ color: "#2F855A" }}>{pqrData.total_production_qty_cum} CUM</span>
                    </Typography> */}
                  </Box>
                </Box>
              )}
             </Box>

          </Box>
        )}

        {!hasData && !loading && (
          <Box sx={{ mt: 4, display: "flex", justifyContent: "center" }}>
            <Typography sx={{ color: "#A0AEC0", fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif" }}>
              Select a plant and date, then click Show to load the report.
            </Typography>
          </Box>
        )}

        <ReusableSnackbar
          open={!!successMessage}
          onClose={(e, r) => { if (r !== "clickaway") setSuccessMessage(""); }}
          message={successMessage}
          autoHideDuration={3000}
          vertical="top" horizontal="right"
          className="no-print"
        />
      </Box>
    </Box>
  );
};

export default MRReport;